import { SignUpStep, SignUpStepSNS } from '~/types';
import { PROJECT } from './projectName';

export const stepTitles: Record<SignUpStep, string> = {
  Agreement: `Agree with ${PROJECT}`,
  CheckEmail: 'What’s your email address?',
  CreatePassword: 'Create your password',
  VerifyEmail: 'Verify your email address',
  Profile: 'Set up your profile',
};

export const signUpSteps: SignUpStep[] = [
  'CheckEmail',
  'CreatePassword',
  'Agreement',
  'Profile',
  'VerifyEmail',
];

export const signUpStepsSNS: SignUpStepSNS[] = ['Agreement', 'Profile'];
